<template>
  <div id="body_maintenance">
    <img id="logo_bb" src="/static/image/error/bb88_logo_w_sponsor.svg" />
    <h1>We are currently undergoing scheduled maintenance.</h1>
    <p>We apologize for the inconvenience. Our site will be back shortly.</p>
    <div id="countdown"></div>
  </div>
</template>

<script>
export default {
  name: 'MaintenancePage',
  data() {
    return {
      countDownDate: new Date("Mar 15, 2024 17:37:25").getTime(),
      timer: null,
    };
  },
  mounted() {
    this.startCountdown();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    startCountdown() {
      this.timer = setInterval(() => {
        const now = new Date().getTime();
        const distance = this.countDownDate - now;

        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        const countdownElement = document.getElementById("countdown");
        if (countdownElement) {
          countdownElement.innerHTML = `${hours}h ${minutes}m ${seconds}s`;
        }

        if (distance < 0) {
          clearInterval(this.timer);
          countdownElement.innerHTML = "EXPIRED";
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
#body_maintenance {
  height: 100%;
  font-family: Arial, sans-serif;
  background-image: url('/static/image/error/background.jpg');
  color: #333;
  text-align: center;
  padding: 50px;
}

#countdown {
  font-size: 50px;
  margin-top: 20px;
}

#logo_bb {
  width: 500px;
}

@media screen and (max-width: 1024px) {
  #logo_bb {
    width: 100%;
  }
}

</style>
